import { RSAA } from 'redux-api-middleware';

export const calculateNumberOfPages = ({ totalResults, pageSize }) => Math.ceil(totalResults / pageSize);

export const copyLastFailedApiAction = (lastFailedApiAction) => ({
	[RSAA]: {
		...lastFailedApiAction[RSAA],
		types: [...lastFailedApiAction[RSAA].types],
		headers: {
			...lastFailedApiAction[RSAA].headers,
		},
	},
});

export const getPickerSearchPlaceholder = ({ showPayees, isManageYourPayee, ukPayees, content }) => {
	const { searchUKPlaceholder, searchInternationalPlaceholder, searchPayeesPlaceholder, searchAccountsPlaceholder } =
		content;
	if (isManageYourPayee) {
		if (ukPayees) {
			return searchUKPlaceholder;
		}
		return searchInternationalPlaceholder;
	}
	if (showPayees) {
		return searchPayeesPlaceholder;
	}
	return searchAccountsPlaceholder;
};

export const getCardViewClass = (listViewSelected) => {
	if (listViewSelected) {
		return 'account-picker__items__item--fullWidth';
	}
	return 'account-picker__items__item--col';
};
